<template>
  <component :is="useCard">
    <div class="flex" style="padding-top: 2rem; padding-bottom: 4rem;">
      <div class="mx-auto flex">
        <!-- [유틸리티공정] -->
        <div class="grid-유틸">
          <h1 class="text-center ">[유틸리티공정]</h1>
          <br />
          <div class="node blue " @click="onClickNode('PU-01')">원수 정수공정<br>(PU-01)</div>
          <br />
          <div class="node blue " @click="onClickNode('PU-02')">용수 정수공정<br>(PU-02)</div>
          <br />
          <div class="node blue " @click="onClickNode('PU-03')">Roll 연마공정<br>(PU-03)</div>
          <br />
          <div class="node blue " @click="onClickNode('PU-04')">Knife 연마공정<br>(PU-04)</div>
          <br />
          <div class="node blue" @click="onClickNode('PU-05')">약품투입공정<br>(PU-05)</div>
        </div>
        <div class="grid-유틸-right-edge">
          <div>
            <span class="border-bottom"></span>
            <span class="border-bottom relative">
              <span class="absolute" style="
                width: 0px;
                height: 0px;
                border-top: 5px solid transparent;
                border-left: 7px solid #cdcdcd;
                border-bottom: 5px solid transparent;
                bottom: -5px;
                right: 0;
              "></span>
            </span>
          </div>
          <div>
            <span class="border-bottom border-right"></span>
            <span></span>
          </div>
          <div>
            <span class="border-bottom border-right"></span>
            <span></span>
          </div>
          <div>
            <span class="border-bottom border-right"></span>
            <span></span>
          </div>
          <div>
            <span class="border-bottom border-right"></span>
            <span></span>
          </div>
        </div>

        <!-- [제품제조공정] -->
        <div class="grid-제품제조공정">
          <h1 class="text-center">[제품제조공정]</h1>
          <br />
          <div class="node blue" @click="onClickNode('P-01')">열간암연/압출공정<br>(P-01)</div>
          <div class="grid grid-cols-2">
            <div></div>
            <div class="border-left border-bottom" style="border-color: #1CE7FF !important;"></div>
            <div></div>
            <div></div>
          </div>
          <div class="node blue" @click="onClickNode('P-02')">제품 시험공정<br>(P-02)</div>
          <br />
          <h1 class="text-center">[기타공정]</h1>
          <br />
          <div class="node blue" @click="onClickNode('PE-01')">위험물 저장공정<br>(PE-01)</div>
        </div>
        <div class="grid-제품제조공정-right">
          <div style="border-bottom: 1px dashed  #cdcdcd"></div>
          <div></div>
          <div>
            <div class="grid">
              <div class="border-bottom relative" style="border-color: #1CE7FF !important;">
                <span class="absolute" style="
                  width: 0px;
                  height: 0px;
                  border-top: 5px solid transparent;
                  border-left: 7px solid #1CE7FF;
                  border-bottom: 5px solid transparent;
                  bottom: -5px;
                  right: 0;
                "></span>
              </div>
              <div></div>
            </div>
            <div class="grid grid-cols-2 border-top border-left">
              <div class="node green" style="border-top: 0; border-left:0;" @click="onClickNode('P-01_생산품')">생산품</div>
              <div class="node green" style="border-top: 0; border-left:0;" @click="onClickNode('P-01_처리')">처리</div>
              <div class="node green" style="border-top: 0; border-left:0;" @click="onClickNode('P-01_후판')">후판</div>
              <div class="node green" style="border-top: 0; border-left:0;" @click="onClickNode('P-01_판매')">판매</div>
            </div>
          </div>
        </div>

        <!-- [환경오염물질 처리공정] -->
        <div class="grid-환경오염물질-left-edge">
          <div>
            <span style="border-bottom: 1px dashed  #cdcdcd"></span>
            <span class="relative" style="border-bottom: 1px dashed  #cdcdcd">
              <span class="absolute" style="
                width: 0px;
                height: 0px;
                border-top: 5px solid transparent;
                border-left: 7px solid #cdcdcd;
                border-bottom: 5px solid transparent;
                bottom: -5px;
                right: 0;
              "></span>
            </span>
          </div>
          <div>
            <span></span>
            <span class="relative" style="border-bottom: 1px dashed  #cdcdcd; border-left: 1px dashed  #cdcdcd">
              <span class="absolute" style="
                width: 0px;
                height: 0px;
                border-top: 5px solid transparent;
                border-left: 7px solid #cdcdcd;
                border-bottom: 5px solid transparent;
                bottom: -5px;
                right: 0;
              "></span>
            </span>
          </div>
          <div>
            <span></span>
            <span class="relative" style="border-bottom: 1px dashed  #cdcdcd; border-left: 1px dashed  #cdcdcd">
              <span class="absolute" style="
                width: 0px;
                height: 0px;
                border-top: 5px solid transparent;
                border-left: 7px solid #cdcdcd;
                border-bottom: 5px solid transparent;
                bottom: -5px;
                right: 0;
              "></span>
            </span>
          </div>
        </div>
        <div class="grid-환경오염물질 relative">
          <h1 class="text-center">[환경오염물질 처리공정]</h1>
          <br />
          <div class="node red" @click="onClickNode('PW-01')">폐수처리공정<br>(물리화학적 폐수처리)<br>(PW-01)</div>
          <br />
          <div class="node red" @click="onClickNode('PW-02')">폐기물 보관공정<br>(지정&일반)<br>(PW-02)</div>
          <br />
          <div class="node red" @click="onClickNode('PW-03')">비점오염 저감공정<br>(PW-03)</div>
          <br />
          <div>
            <div class="absolute grid"
                 style="bottom: 0; right:0; width: 260px;
                        grid-template-rows: 24px 8px 170px">
              <h1>※ 범 례</h1>
              <br />
              <div class="grid p-4 gap-4" style="border: 1px solid #cdcdcd;">
                <div class="flex align-center">
                  <div class="flex items-center mr-2">
                    <span class="relative" style="width: 70px; height: 1px; border-bottom: 1px solid #000000">
                      <span class="absolute" style="
                        width: 0px;
                        height: 0px;
                        border-top: 5px solid transparent;
                        border-left: 7px solid #000;
                        border-bottom: 5px solid transparent;
                        bottom: -5px;
                        right: 0;
                      "></span>
                    </span>
                  </div>
                  원료(Slab), 공정수 </div>
                <div class="flex align-center">
                  <div class="flex items-center mr-2">
                    <span class="relative" style="width: 70px; height: 1px; border-bottom: 1px solid #1CE7FF">
                      <span class="absolute" style="
                        width: 0px;
                        height: 0px;
                        border-top: 5px solid transparent;
                        border-left: 7px solid #1CE7FF;
                        border-bottom: 5px solid transparent;
                        bottom: -5px;
                        right: 0;
                      "></span>
                    </span>
                  </div>
                  생산품(후판) </div>
                <div class="flex align-center">
                  <div class="flex items-center mr-2">
                    <span class="relative" style="width: 70px; height: 1px; border-bottom: 1px dashed #000000">
                      <span class="absolute" style="
                        width: 0px;
                        height: 0px;
                        border-top: 5px solid transparent;
                        border-left: 7px solid #000;
                        border-bottom: 5px solid transparent;
                        bottom: -5px;
                        right: 0;
                      "></span>
                    </span>
                  </div>
                  환경오염물질 <br> (폐수, 대기오염물질 등) </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    card: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    useCard() {
      if (this.card) {
        return 'vx-card'
      }

      return 'div'
    }
  },
  methods: {
    onClickNode(itemId) {
      this.$emit('node', itemId)
    }
  }
}
</script>

<style lang="scss" scoped>
h1 { font-size: 1.15rem; font-weight: 700; line-height: 23.17px }
.node {
  padding: 10px;
  display: flex;
  border: 1px solid #B6B6B6;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &.blue { background-color: #F0F4FF }
  &.red { background-color: #FFFBF0 }
  &.green { background-color: #F0FFFE }

  &:hover { background-color: #E5E5E5; border: 1px solid #000000 !important; }
}
.grid-유틸 {
  display: grid;
  width: 200px;
  grid-template-rows: 24px 16px 100px 16px 100px 16px 100px 16px 100px 16px 100px;
}
.grid-유틸-right-edge {
  display: grid;
  width: 66px;
  grid-template-rows: 90px 116px 116px 116px 116px;

  & > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
.grid-제품제조공정 {
  display: grid;
  width: 200px;
  grid-template-rows: 24px 16px 100px 100px 100px 100px 24px 16px 100px;
}
.grid-제품제조공정-right {
  display: grid;
  width: 160px;
  grid-template-rows: 90px 50px 100px;

  & > div {
    display: grid;
    grid-template-columns: 10px auto;
  }
}
.grid-환경오염물질-left-edge {
  display: grid;
  width: 60px;
  grid-template-rows: 90px 116px 116px ;

  & > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
.grid-환경오염물질 {
  display: grid;
  width: 200px;
  grid-template-rows: 24px 16px 100px 16px 100px 16px 100px 1fr;
}
</style>
